<template>
<div class="card ribbon-box right bg-light card-height-100 profile-project-card shadow-none profile-project-primary">
    <div v-if="item.is_highest" class="ribbon-two ribbon-two-primary"><span>Highest</span></div>
    <div class="card-body">
        <div class="row g-2">
            <div class="col-2 mb-3"> 
                <slot name="actions"></slot>
            </div>
            <div class="col-8 mb-3"> 
                <span class="text-muted d-none d-sm-inline me-3">Status</span>
                <span v-html="statusBadge(item.status)"> </span>
            </div>
            <div  class="col-12"> 
                <span class="text-muted">Qualification</span>
                <h6> {{item.qualification_title}} <span v-if="item.qualification_description">- {{ item.qualification_description }}</span></h6>
            </div>
            <div class="col-12"> 
                <span class="text-muted">Institution <span >({{ item.institution_type }})</span></span>
                <h6> {{ item.institution_title || item.institution_name }} </h6>
            </div> 
            <div v-if="item.course_title || item.course_name" class="col-12"> 
                <span class="text-muted">Course of Study</span>
                <h6> {{item.course_title || item.course_name }} </h6>
            </div>
            <div v-if="item.cgpa" class="col-sm-6"> 
                <span class="text-muted">CGPA</span>
                <h6> {{ item.cgpa }} out of {{ item.grading_scale }}  </h6>
            </div>
            <div class="col-sm-6"> 
                <span class="text-muted">Duration</span>
                <h6> {{ $filters.number_format(item.duration)}} yrs </h6>
            </div>
            <div class="col-12">
                <div class="row g-2">
                    <div class="col-sm-6"> 
                        <span class="text-muted">Start Date</span>
                        <h6> {{ $filters.date(item.start_date)}} </h6>
                    </div>
                    <div class="col-sm-6"> 
                        <span class="text-muted">End Date</span>
                        <h6> {{ $filters.date(item.end_date)}} </h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
export default {
    props:{
        item:{
            type:Object,
            required: true
        }
    }, 
}
</script>

<style>

</style>